<template>
    <Card title="Venues">
        <template #title>
            Venues
        </template>
        <template #actions>
            <button
                type="button"
                class="btn btn-primary"
                @click="showAddModal"
            >
                Add venue
            </button>
        </template>
        <VenuesTable />
        <VenueModal />
        <DeleteModal />
    </Card>
</template>

<script>
import Card from '@/components/Card';
import VenuesTable from '@/modules/venues/_components/VenuesTable';
import VenueModal from '@/modules/venues/_components/VenueModal';
import DeleteModal from '@/modules/venues/_components/DeleteModal';
import store from './_store';

export default {
    components: {
        Card,
        VenuesTable,
        VenueModal,
        DeleteModal,
    },
    props: {
        eventId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.registerModule('venues', store);
    },
    async mounted() {
        await this.$store.dispatch('venues/setEventId', this.eventId);
        await this.$store.dispatch('venues/loadVenues');
    },
    methods: {
        showAddModal() {
            this.$store.dispatch('venues/setShowAddModal', true);
        },
    },
};
</script>
